<div class="mmp-dialog survey-feedback-dialog">
  <div class="modal-header mmp-dialog-header">
    <h4 class="modal-title mmp-dialog-title" id="survey-feedback-modal-title">We value your feedback</h4>
    <button type="button" class="close" aria-label="Close" (click)="onNotNow()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body mmp-dialog-body survey-feedback-dialog-body">
    <div class="survey-feedback-dialog-brand">
      <img
        src="/assets/img/brand/mymeds-logo-full.svg"
        alt="MyMedsPH"
        class="survey-feedback-dialog-logo"
      />
    </div>

    <article class="survey-feedback-dialog-panel">
      <p class="survey-feedback-dialog-lead">
        <strong>Thank you for being a valued MyMedsPH user!</strong>
      </p>
      <p class="survey-feedback-dialog-text">
        Your feedback helps us improve and ensure the system truly supports your needs.
      </p>
      <p class="survey-feedback-dialog-text">
        This short survey will only take a few minutes, and your insights will directly guide future
        enhancements.
      </p>
      <p class="survey-feedback-dialog-note">
        We deeply appreciate your time and honest thoughts — they make a real difference.
      </p>
    </article>
  </div>

  <div class="modal-footer mmp-dialog-footer survey-feedback-dialog-footer">
    <button type="button" class="btn-export-outline" (click)="onNotNow()">
      <i class="fas fa-times" aria-hidden="true"></i>
      Not now
    </button>
    <button type="button" class="btn-show" (click)="onStartSurvey()">
      <i class="fas fa-clipboard-list" aria-hidden="true"></i>
      Start survey
    </button>
  </div>
</div>
